/**
 * Riyal — the official Saudi Riyal currency symbol, theme-safe.
 *
 * Uses the official symbol asset (black on transparent) and inverts it in dark mode
 * (dark:invert → white) so it stays visible on any background.
 *
 * Two sizing modes:
 *   - Inline with text (default): sized in `em` so it scales with surrounding text.
 *       <span>{amount} <Riyal /></span>
 *   - As an ICON in a slot that passes a numeric `size` (Badge, StatCard, menus,
 *     buttons — same API as react-icons): rendered at `size` pixels.
 *       icon={Riyal}   →   <Riyal size={18} />
 */
import React from 'react';

export default function Riyal({ className = '', size }) {
  const hasSize = size != null && size !== '';
  const style = hasSize ? { height: `${size}px`, width: `${size}px` } : undefined;
  // Icon-slot mode (numeric size — Button/Badge/menu slots) is decorative:
  // the slot always sits beside its own text label, and an alt of "SAR"
  // would leak into the control's accessible name ("SAR Pay" instead of
  // "Pay"). Inline-with-amount mode keeps alt so screen readers hear the
  // currency next to the number.
  const a11y = hasSize ? { alt: '', 'aria-hidden': true } : { alt: 'SAR', 'aria-label': 'SAR' };
  return (
    <img
      src="/Saudi_Riyal_Symbol.svg.png"
      {...a11y}
      style={style}
      className={`inline-block align-[-0.05em] dark:invert ${hasSize ? '' : 'h-[0.85em] w-[0.85em]'} ${className}`}
    />
  );
}
